export default __webpack_public_path__ + "static/media/gy.e948cf4f.svg";